import { render } from "./AllBlocksList.vue?vue&type=template&id=4176e3ef&scoped=true"
import script from "./AllBlocksList.vue?vue&type=script&lang=js"
export * from "./AllBlocksList.vue?vue&type=script&lang=js"

import "./AllBlocksList.vue?vue&type=style&index=0&id=4176e3ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4176e3ef"]])

export default __exports__